import { openPlaceTokenClient } from './client'
import type { BPlateDetail, BJourney, BJourneyInterviewerForm } from '../types'
import type { submitJourneyInterviewer } from './brainer'

// Public, unauthenticated OpenPlace surface — see openplace-token.routes.ts on the backend.
// The server always resolves scopeCoffeeId from the token itself and force-injects it into
// every view run, overriding anything sent in inputParams, so the caller never needs to (or
// safely can) supply it directly.
export const getOpenPlaceTokenPlate = (token: string) =>
  openPlaceTokenClient.get<BPlateDetail & { scopeCoffeeId?: string }>(`/openplace-token/${token}`)

export const runOpenPlaceTokenView = (token: string, viewId: string, inputParams: Record<string, string>) =>
  openPlaceTokenClient.post<{ data: unknown; error?: string }>(`/openplace-token/${token}/views/${viewId}/run`, { inputParams })

// Phase 3b manual override / kill switch — the same token-scoped, force-injected-scopeCoffeeId
// convention as the view-run route above. The server also restricts preparationId to whatever
// this token's own plate actually exposes as a button/row-action (see
// collectAllowedPreparationIds in openplace-token.routes.ts) — a 403 here means the requested
// preparation isn't one of this dashboard's own controls.
export const triggerOpenPlaceTokenJourney = (token: string, preparationId: string, initialPayload?: Record<string, string>) =>
  openPlaceTokenClient.post<BJourney>(`/openplace-token/${token}/journeys/trigger`, { preparationId, initialPayload })

export const getOpenPlaceTokenJourney = (token: string, journeyId: string) =>
  openPlaceTokenClient.get<BJourney>(`/openplace-token/${token}/journeys/${journeyId}`)

// A paused journey's form on the public page (e.g. a client's refusal comment) — the server only
// serves journeys this same link started (scopeCoffeeId must match the token's).
export const getOpenPlaceTokenInterviewer = (token: string, journeyId: string) =>
  openPlaceTokenClient.get<BJourneyInterviewerForm>(`/openplace-token/${token}/journeys/${journeyId}/interviewer`)

export const submitOpenPlaceTokenInterviewer = (token: string, journeyId: string, d: Parameters<typeof submitJourneyInterviewer>[1]) =>
  openPlaceTokenClient.post<Awaited<ReturnType<typeof submitJourneyInterviewer>>['data']>(`/openplace-token/${token}/journeys/${journeyId}/interviewer`, d)
